import { createApi } from '@reduxjs/toolkit/query/react';
import { gql } from 'graphql-request';
import { baseQuery } from '@classity-edtech/ui-base';
import { LANGUAGE } from '../store/actionTypes';
import { Language } from './models/languages';

export const languages = createApi({
  reducerPath: LANGUAGE,
  baseQuery,
  tagTypes: ['language'],
  endpoints: builder => ({
    languages: builder.query<Language[], void>({
      query: variables => ({
        document: gql`
          query GetLanguages($page: Int, $limit: Int) {
            getLanguages(page: $page, limit: $limit) {
              code
              id
              name {
                description
                language
                text
              }
            }
          }
        `,
        variables,
      }),
      transformResponse: (response: any) => response?.getLanguages,
    }),
  }),
});

export const { useLanguagesQuery } = languages;
